import React from "react";

const Loader = ({ size = "48", border = "border-8", color = "primary", loadingMessage = "" }) => {
  var topColor = color === "primary" ? "border-t-primary" : "border-t-[#292D32]";
  var bottomColor = color === "primary" ? "border-b-primary" : "border-b-[#292D32]";

  return (
    <div className="w-full flex justify-center items-center flex-col">
      <div style={{ width: `${size}px`, height: `${size}px` }} className="animate-spin">
        <div className={`h-full w-full ${border} ${topColor} ${bottomColor} rounded-[50%]`}></div>
      </div>
      {loadingMessage && <div className="ml-4 text-primary">{loadingMessage}</div>}
    </div>
  );
};

export default Loader;
